/**
 * Modal emit me
 * au_form watch listen me 
 * on true is submitForm
 * 
*/
export default {
    state: {
        au_status_2_4: false,
        au_status_2_2: false,
        au_status_8_1: false,
        au_status_8_2: false,
        au_status_8_3: false,
        au_status_8_4: false,
        au_status_8_4_courseChapter: false,//【课程管理】=>课程章节设置
        au_status_8_5: false,
        au_status_8_6: false,
        au_status_8_12: false,
    },
    getters: {
        get_auForm_status: (state) => {
            return (pageKey) => {
                const stateName = `au_status_` + pageKey;
                return state[stateName];
            }
        }
    },
    mutations: {
        set_auForm_status:(state,config={pageKey,bool})=>{state[`au_status_`+config.pageKey]=config.bool;console.log("set => watchFormStatus",config);},
    },
    actions: {},

}


// WEBPACK FOOTER //
// ./src/vuex/formStatus.js